




























import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {QueryStandingBook,QueryStandingBookDetail} from '../../../api/pharmacy'
import Detail from './detail.vue'
import Util from '../../../lib/util'


@Component({
    components:{Detail}
})
export default class Inventory extends AbpBase {
	//名称检索
	@Watch('drugName')
	WatchdrugName(val: any, oldVal: any) { 
		this.getData()
	}
	//会计期间检索
	@Watch('periodDate')
	WatchperiodDate(val: any, oldVal: any) { 
		this.getData()
	}
	// //日期范围检索
	// @Watch('date')
	// Watchdate(val: any, oldVal: any) { 
	// 	this.getData()
	// }
	drugName = ''//名称检索
    list = []//table数据源
    DetailShow:boolean=false;
	DetailData = ''
	// date:any = [];
	periodDate:any='';
	table = {
		loading:false,
		modalShow : false,//modal是否显示
		totalCount : 0,
		pageSize : 10,
		currentPage:1
    }
    
	created(){
        this.getData()
	}
	async getData(){
		this.table.loading = true
		let payload = {
			queryString:this.drugName,
			tjqYear:this.periodDate==''?'':Util.dateConversion(this.periodDate).split('-')[0],
			tjqMonth:this.periodDate==''?'':Util.dateConversion(this.periodDate).split('-')[1],
			// startTime:this.date[0],
			// endTime:this.date[1],
			pageSize:this.table.pageSize,
			Page:this.table.currentPage
		}
		let response = await QueryStandingBook(payload)
		this.list = response.data.items
	
		this.table.totalCount = response.data.totalCount
		this.table.loading = false
	}
	pageChange(page: number) {
		this.table.currentPage = page
		this.getData()
    }
    
    //详情
    detail(c:any){
        this.DetailShow = true;
		this.DetailData = c
    }
	columns = [{
		title: "药品名称",
		key: 'drugName'
	},{
		title: "拼音",
		key: 'py'
	},{
		title: "五笔",
		key: 'wb'
	},{
		title: "规格型号",
		key: 'medicineModel'
	},{
		title: "厂商",
		key: 'placeOfOrigin'
	},{
		title: "期初数量",
		key: 'beginQuantity'
	},{
		title: "入库数量",
		key: 'inHouseQuantity'
	},{
		title: "出库数量",
		key: 'outHouseQuantity'
	},{
		title: "报损数量",
		key: 'breakageQuantity'
	},{
		title: "盘点数量",
		key: 'checkQuantity'
	},{
		title: "结存数量",
		key: 'jcQuantity'
	},{
		title: "结存进价",
		key: 'jcPurchasePrice'
	},{
		title: "结存零价",
		key: 'jcZeroPrice'
	},
    {
		title: this.L('Actions'),
		key: 'Actions',
		width: 80,
		render: (h: any, params: any) => {
			return h('div', [
				h('Button', {
					props: {
						type: 'primary',
						size: 'small'
					},
					style: {
						marginRight: '5px'
					},
					on: {
						click: () => {
							this.detail(params.row)
						}
					}
                }, '明细'),
			])
		}
	}]
	
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pharmacy/inventory/index.vue